import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInclusionsInside = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11.976 15h24.048a1.69 1.69 0 0 1 1.365.695l6.45 8.868a.844.844 0 0 1-.063 1.068L24.62 46.383a.843.843 0 0 1-1.19.047q-.017-.014-16.787-18.181L4.225 25.63a.84.84 0 0 1-.063-1.068l6.45-8.868A1.69 1.69 0 0 1 11.976 15m.86 3.374L8.112 24.87 24 42.078 39.888 24.87l-4.724-6.496zM18 20h6v7h-4v-4h-2z" })
});
export default SvgInclusionsInside;
